import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

export default function Scenario() {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="max-w-4xl mx-auto mt-16 px-4 sm:px-0">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.05)] border border-blue-50 overflow-hidden"
      >
        <button 
          onClick={() => setIsExpanded(!isExpanded)}
          className="w-full flex items-center justify-between p-8 bg-gradient-to-r from-slate-50/50 to-white hover:from-blue-50/50 transition-all group"
        >
          <div className="flex items-center gap-5">
            <div className="p-3 bg-indigo-600 rounded-2xl shadow-lg shadow-indigo-100 group-hover:scale-110 transition-transform">
              <SafeIcon name="User" className="w-6 h-6 text-white" />
            </div>
            <div className="text-left">
              <h2 className="text-2xl font-bold text-slate-900">Your Scenario</h2>
              <p className="text-slate-500 font-medium">Meet the Coleman Family</p>
            </div>
          </div>
          <div className={`p-2 rounded-full transition-all duration-300 ${isExpanded ? 'rotate-180 bg-slate-100' : 'bg-blue-600 shadow-lg shadow-blue-200'}`}>
            <SafeIcon name="ChevronDown" className={`w-6 h-6 ${isExpanded ? 'text-slate-500' : 'text-white'}`} />
          </div>
        </button>

        <AnimatePresence>
          {isExpanded && (
            <motion.div 
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              className="overflow-hidden"
            >
              <div className="p-10 grid grid-cols-1 md:grid-cols-2 gap-12 border-t border-slate-50">
                <div className="space-y-8">
                  <div className="relative pl-8 border-l-4 border-indigo-500">
                    <h3 className="text-xs font-black text-indigo-500 uppercase tracking-[0.3em] mb-3">The Prospect</h3>
                    <div className="space-y-4">
                      <p className="text-slate-800 text-xl font-medium leading-relaxed">
                        Ray Coleman, 49: African American father and facilities operations supervisor at a regional hospital system.
                      </p>
                      <p className="text-slate-600 leading-relaxed italic bg-slate-50 p-4 rounded-xl border border-slate-100">
                        Ray is methodical, warm, and unhurried. He is thinking in ten year horizons and comparing four schools. He drives the questions.
                      </p>
                    </div>
                  </div>
                  
                  <div className="relative pl-8 border-l-4 border-teal-500">
                    <h3 className="text-xs font-black text-teal-600 uppercase tracking-[0.3em] mb-3">The Student</h3>
                    <p className="text-slate-800 text-lg">
                      Marcus: High school junior with a 3.4 GPA. He is interested in engineering and drafting.
                    </p>
                  </div>
                </div>

                <div className="space-y-6">
                  <motion.div 
                    whileHover={{ x: 10 }}
                    className="bg-emerald-50/50 p-7 rounded-[2rem] border border-emerald-100 relative overflow-hidden group"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <div className="p-2 bg-emerald-500 rounded-lg shadow-md shadow-emerald-100">
                        <SafeIcon name="Target" className="w-5 h-5 text-white" />
                      </div>
                      <h3 className="font-bold text-emerald-900 text-lg">Success Path</h3>
                    </div>
                    <p className="text-emerald-800 leading-relaxed font-medium">
                      Ask genuine, specific, and open questions to unlock real insights about cost, outcomes, support, and whether Marcus feels wanted.
                    </p>
                  </motion.div>
                  
                  <motion.div 
                    whileHover={{ x: 10 }}
                    className="bg-rose-50/50 p-7 rounded-[2rem] border border-rose-100 relative overflow-hidden group"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <div className="p-2 bg-rose-500 rounded-lg shadow-md shadow-rose-100">
                        <SafeIcon name="AlertTriangle" className="w-5 h-5 text-white" />
                      </div>
                      <h3 className="font-bold text-rose-900 text-lg">Avoid This</h3>
                    </div>
                    <p className="text-rose-800 leading-relaxed font-medium">
                      Do not let the conversation stay at the surface level. Avoid generic talk about programs and class sizes without deeper engagement.
                    </p>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}